;(function($, window, document, undefined) {
  var $win = $(window);
  var $doc = $(document);
  var isLoading = false;

  //Animate Sections
  var $animated = $('.animated');
  var scrolledY = 0;

  var winHeight = $win.height();
  var winWidth = $win.width();
  var winScroll = $win.scrollTop();

  function animateElements() {
    winScroll = $win.scrollTop();

    if ( $animated.length === 0 ) {
      return;
    }
  };


  function animate(winST) {
  $('.animate').each(function(){
    var $this = $(this);
    var idx = 1.3

    if ($win.width() < 767) {
      idx = 1.1
    }

    if (winST + ($win.outerHeight() / idx) > $this.offset().top) {
      $this.addClass('animated');
    } else if (winST + ($win.outerHeight() / 2) < $this.offset().top) {
      $this.removeClass('animated');
    }
    });
  }

  $doc.ready(function() {
    (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports) {
    'use strict';

    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

    var _classToggle = require('./modules/class-toggle.js');

    var _classToggle2 = _interopRequireDefault(_classToggle);

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

    $('.section-list').on('click', 'a.btn', function(e) {
      e.preventDefault();
      $(this).toggleClass('hidden');
      $(this).siblings().toggleClass('hidden');

      $('.section-list .list-block-more').each(function() {
        var $this = $(this);
        $this.slideToggle(600);
      });
    })

    var App = function () {
      function App() {
        _classCallCheck(this, App);

        this.$win = $(window);
        this.$doc = $(document);
        this.$ssTrigger = $('.js-scrollspy');
        this.$header = $('.header');
        this.$ddElement = $('.nav-dd');
        this.classes = {
          animated: 'animated',
          reveal: 'reveal',
          active: 'active',
          scrolled: 'scrolled',
          visible: 'visible'
        };
        this.sliders = [{
          $container: $('.slider-testimonials'),
          $slides: $('.slider__slides'),
          settings: {
            arrows: false,
            dots: true,
            adaptiveHeight: true
          }
        }];

        this.windowEvents();
        this.scrollspy();
        this.locateDropdown();
        this.startSliders();
        this.clickEvents();
        this.responsiveSlider($('.row--slider'), 768, {
          arrows: false,
          dots: true,
          adaptiveHeight: true
        });
        this.responsiveSlider($('.section-widgets .section__body .row'), 768, {
          arrows: false,
          dots: true,
          swipeToSlide: false,
          touchMove: false,
        });

        new _classToggle2.default('.js-class');
      }

      _createClass(App, [{
        key: 'windowEvents',

        /**
      * Window Events
      */
        value: function windowEvents() {
          var _this = this;

          this.$win.on('load scroll', function () {
            _this.winST = _this.$win.scrollTop();

            // Toggle scrolled header
            _this.$header.toggleClass(_this.classes.scrolled, _this.winST > 0);
          });
        }
      }, {
        key: 'startSliders',

        /**
      * Start Sliders
      */
        value: function startSliders() {
          var self = this;

          self.sliders.forEach(function (slider) {
            var $container = slider.$container,
                $slides = slider.$slides,
                settings = slider.settings;
            $container.find($slides).not('.slick-initizalized').slick(settings);
          });
        }
       }, {
        key: 'clickEvents',

        /**
      * Start Sliders
      */
        value: function clickEvents() {

          var self = this;
          $('.single-crb_product .nav__dropdown').on('click', 'a', function(e) {
              e.preventDefault();

              if ( isLoading ) {
                return;
              }


              var newPageLink = $(this).attr('href');
              window.history.pushState( '', '', newPageLink );
              self.loadProductPage( newPageLink )

              setTimeout(function() {
                $('.intro-main').addClass('animated')
              }, 500);
          })
        }

      }, {

         key: 'loadProductPage',
      /**
      * Start Sliders
      */
        value: function loadProductPage(link) {
          var self = this;
          var $sectionContent  = $('.wrapper-inner');
          var $adminBarContainer = $('#wpadminbar');
          $sectionContent.fadeOut(300);

          $.ajax({
            url: link,
            type: "GET",
            beforeSend: function(){
              isLoading = true;
             },
          }).done( function(response){
            var $newSectionContent  = $('.wrapper-inner', response);
            var $newAdminBarContainer = $('#wpadminbar', response);

            $adminBarContainer.html($newAdminBarContainer.html());
            $sectionContent.html($newSectionContent.html());
            $('.wrapper-inner').fadeIn(300);
            $('.intro').addClass('animated');
            isLoading = false;

            document.title = $(response).filter('title').text();
          })
        }

      }, {
        key: 'responsiveSlider',

        /**
      * Responsive Slider
      */
        value: function responsiveSlider($slides, activeAfter, options) {
          var self = this;
          var allowSlider = true;

          $slides.each(function () {
            var $slider = $(this);

            self.$win.on('load resize', function () {
              var width = self.$win.outerWidth();

              if (width < activeAfter && allowSlider) {
                $slider.slick(options);

                allowSlider = false;
              } else if (width > activeAfter && !allowSlider) {
                $slider.slick('unslick');

                allowSlider = true;
              }
            });
          });
        }
      }, {
        key: 'scrollspy',

      /**
      * Scrollspy
      */
        value: function scrollspy() {
          this.$ssTrigger.on('click', function (e) {
            e.preventDefault();

            var $trigger = $(this);
            var $target  = $trigger.data('target') ? $($trigger.data('target')) : $($trigger.attr('href'));
            var offset   = $trigger.data('offset') ? $trigger.data('offset') : 90;
            var timing   = $trigger.data('timing') ? $trigger.data('timing') : 600;

            $('html, body').animate({
              scrollTop: $target.offset().top - offset
            }, timing);
          });
        }
      }, {
        key: 'locateDropdown',

      /**
      * Locate Dropdown
      */
        value: function locateDropdown() {
          var self = this;

          self.$ddElement.each(function () {
            var $li = $(this).find('ul').parents('li');

            $li.addClass('has-dd');

            $li.find('> a').addClass('js-class').attr({
              'data-traverse': 'parent',
              'data-target': 'li',
              'data-class': self.classes.active
            });
          });
        }
      }, {
        key: 'startSliders',

      /**
      * Start Sliders
      */
        value: function startSliders() {
          var self = this;

          self.sliders.forEach(function (slider) {
            var $container = slider.$container,
                $slides = slider.$slides,
                settings = slider.settings;
                $container.find($slides).slick(settings);
                $container.find($slides).slick('resize');
          });
        }
      }]);

      return App;
    }();

    var application = new App();

    },{"./modules/class-toggle.js":2}],2:[function(require,module,exports){
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

    var ClassToggle = function () {
        function ClassToggle(toggler) {
            _classCallCheck(this, ClassToggle);

            this.button = toggler;

            this.init();
        }

        _createClass(ClassToggle, [{
            key: 'init',
            value: function init() {
                var self = this;

                self.toArray(document.querySelectorAll(this.button)).forEach(function (btn) {
                    btn.addEventListener('click', function (e) {
                        e.preventDefault();

                        var target = self.getTraverse(btn);
                        var type = btn.dataset.type;
                        var className = btn.dataset.class;

                        switch (type) {
                            case 'add':
                                target.classList.add(className);

                                break;
                            case 'remove':
                                target.classList.remove(className);

                                break;
                            default:
                                target.classList.toggle(className);

                                break;
                        }
                    });
                });
            }
        }, {
            key: 'getTraverse',
            value: function getTraverse(btn) {
                var traverse = btn.dataset.traverse ? btn.dataset.traverse.split('~') : '';
                var match = traverse[0];
                var element = traverse[1];
                var target = btn.dataset.target;

                switch (match) {
                    case 'parent':
                        return this.findAncestor(btn, target);
                        break;
                    case 'find':
                        return this.findAncestor(btn, element).querySelector(target);
                        break;
                    case 'sibling':
                        return btn.parentNode.querySelector(target);
                        break;
                    default:
                        return document.querySelector(btn.dataset.target);
                }
            }
        }, {
            key: 'findAncestor',
            value: function findAncestor(element, ancestor) {
                while ((element = element.parentElement) && !(element.matches || element.msMatchesSelector).call(element, ancestor)) {}
                return element;
            }
        }, {
            key: 'toArray',
            value: function toArray(nodelist) {
                var arr = [];

                for (var index = 0; index < nodelist.length; index++) {
                    arr.push(nodelist[index]);
                }

                return arr;
            }
        }]);

        return ClassToggle;
    }();

    exports.default = ClassToggle;

    },{}]},{},[1]);

  $win.on('load', function() {
    animateElements();

    // setTimeout(function() {
    //   $('body').addClass('animate-intro')

    //   $('.intro-main').addClass('animated')
    // }, 500);

  }).on('scroll load', function() {
      scrolledY = $win.scrollTop();
      animate(scrolledY);
  })

  });
})(jQuery, window, document);
